import {Injectable} from '@angular/core';
import {UserService} from "./user.service";

@Injectable({
    providedIn: 'root'
})
export class SecurityService {

    constructor(
        private user: UserService,
    ) {
    }

    public existeSesion() {
        const token = this.getToken();
        return token && token != '';
    }


    public getToken(){
        return this.user.userToken;
    }


}

